module.exports = __webpack_public_path__ + "357860c5ec857a9ecfb5b19cf27bd204.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/less/tourconnect-icons/fonts/TourConnect-Icons.ttf?kx9bpm
// module id = 478
// module chunks = 1 2 3 4 5 6 7 8 9